import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {Injectable, LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {TranslateModule} from '@ngx-translate/core';
import {TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {MaterialModule} from './material/material.module';
import {HelperService} from './service/helper.service';
import {LayoutComponent} from './components/layout/layout.component';
import {LoginLayoutComponent} from './components/layout/login-layout/login-layout.component';
import {LoginComponent} from './components/login/login.component';
import {ForgotPasswordComponent} from './components/forgot-password/forgot-password.component';
import {ResetPasswordComponent} from './components/reset-password/reset-password.component';
import {SignupSubmitComponent} from './components/signup-submit/signup-submit.component';
import {HomeLayoutComponent} from './components/layout/home-layout/home-layout.component';
import {HeaderComponent} from './components/navigation/header/header.component';
import {RFQsComponent} from './components/rfqs/rfqs.component';
import {MyAccountComponent} from './components/my-account/my-account.component';
import {MyQuotesComponent} from './components/my-account/my-quotes/my-quotes.component';
import {ApiService} from './service/api.service';
import {AuthGuardService} from './service/auth-guard.service';
import {ChangePasswordComponent} from './components/my-account/change-password/change-password.component';
import {DeleteAccountComponent} from './components/my-account/delete-account/delete-account.component';
import {DeletePopupComponent} from './popups/delete-popup/delete-popup.component';
import {EditProfileComponent} from './components/my-account/edit-profile/edit-profile.component';
import {OnbordingLayoutComponent} from './components/layout/onbording-layout/onbording-layout.component';
import {QuotationComponent} from './components/quotation/quotation.component';
import {QuotationDetailsComponent} from './components/quotation-details/quotation-details.component';
import {PrivacyPolicyComponent} from './components/privacy-policy/privacy-policy.component';
import {TermsConditionComponent} from './components/terms-condition/terms-condition.component';
import {SearchPipe} from './pipes/search.pipe';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {AngularIbanModule} from 'angular-iban';
import {MatSelectFilterModule} from 'mat-select-filter';
import {DateAdapter, MAT_DATE_LOCALE, NativeDateAdapter} from '@angular/material/core';
import {CurrencyPipe, registerLocaleData} from '@angular/common';
import localeIt from '@angular/common/locales/it';
import {ActivityLogComponent} from './components/my-account/activity-log/activity-log.component';
import {ConfirmDialogPopupComponent} from './popups/confirm-dialog-popup/confirm-popup.component';
import {ServiceWorkerModule} from '@angular/service-worker';
import {MatSnackBarModule} from "@angular/material/snack-bar";
import { MatDialogModule } from '@angular/material/dialog';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { CustomerDeclineComponent } from './components/customer-decline/customer-decline.component';
import { CustomerRegistrationComponent } from './components/customer-registration/customer-registration.component';
import { SidenavListComponent } from './components/navigation/sidenav-list/sidenav-list.component';
import { environment } from '../environments/environment';
import { BreadcrumbComponent } from './components/global/breadcrumb/breadcrumb.component';
import { PaginationComponent } from './components/global/pagination/pagination.component';
import { WheelActionComponent } from './components/global/wheel-action/wheel-action.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SortTableColumnComponent } from './components/global/sort-table-column/sort-table-column.component';
import { SetPasswordComponent } from './components/set-password/set-password.component';
import { CreateOrderComponent } from './components/manage-orders/create-order/create-order.component';
import { ManageOrdersComponent } from './components/manage-orders/manage-orders.component';
import { ViewOrderHistoryComponent } from './components/manage-orders/view-order-history/view-order-history.component';
import { CustomerManageOrdersService } from './service/cutomer-manage-order.service';
import { TokenInterceptor } from './service/token.interceptors';
import { AddEditInternalCommentsPopupOrderComponent } from './popups/add-edit-internal-comments-popup-order/add-edit-internal-comments-popup-order.component';
import { ApproveRejectOrderComponent } from './popups/approve-reject-order/approve-reject-order.component';
import { CustomerSellingCatalogComponent } from './components/customer-selling-catalog/customer-selling-catalog.component';
import { SellingCatalogDetailComponent } from './components/customer-selling-catalog/selling-catalog-detail/selling-catalog-detail.component';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { OrderPlanningComponent } from './components/manage-orders/order-planning/order-planning.component';
import { HttpService } from './service/httpService';
import { CustomCurrencyPipe } from './pipes/custom-currency.pipe';
import { ManageOrderListingComponent } from './components/manage-order-listing/manage-order-listing.component';
import { OrderDetailsComponent } from './components/manage-order-listing/order-details/order-details.component';
import { OrderTaskDetailComponent } from './components/manage-order-listing/order-task-detail/order-task-detail.component';
import { NgxMaskModule,NgxMaskPipe, optionsConfig  } from 'ngx-mask';
import { CustomTimeDurationPipe } from './pipes/custom-time-duration.pipe';
import { NgPipesModule } from 'ngx-pipes';
registerLocaleData(localeIt);

@Injectable()
export class MyDateAdapter extends NativeDateAdapter {
    getFirstDayOfWeek(): number {
        return 1;
    }
}

@NgModule({
    declarations: [
        CustomCurrencyPipe,
        AppComponent,
        LayoutComponent,
        LoginLayoutComponent,
        LoginComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        SignupSubmitComponent,
        HomeLayoutComponent,
        HeaderComponent,
        RFQsComponent,
        MyAccountComponent,
        MyQuotesComponent,
        ChangePasswordComponent,
        DeleteAccountComponent,
        DeletePopupComponent,
        EditProfileComponent,
        OnbordingLayoutComponent,
        QuotationComponent,
        QuotationDetailsComponent,
        PrivacyPolicyComponent,
        TermsConditionComponent,
        SearchPipe,
        ActivityLogComponent,
        ConfirmDialogPopupComponent,
        DashboardComponent,
        CustomerDeclineComponent,
        CustomerRegistrationComponent,
        SidenavListComponent,
        BreadcrumbComponent,
        PaginationComponent,
        WheelActionComponent,
        SortTableColumnComponent,
        SetPasswordComponent,
        ManageOrdersComponent,
        CreateOrderComponent,
        ViewOrderHistoryComponent,
        AddEditInternalCommentsPopupOrderComponent,
        ApproveRejectOrderComponent,
        CustomerSellingCatalogComponent,
        SellingCatalogDetailComponent,
        OrderPlanningComponent,
        ManageOrderListingComponent,
        OrderDetailsComponent,
        OrderTaskDetailComponent,
        CustomTimeDurationPipe,
    ],
    imports: [
        NgxMaskModule.forRoot(),
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MaterialModule,
        HttpClientModule,
        NgxMatSelectSearchModule,
        AngularIbanModule,
        MatSelectFilterModule,
        MatDialogModule,
        MatSnackBarModule,
        NgxPaginationModule,
        NgPipesModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            // Register the ServiceWorker as soon as the app is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
            // registrationStrategy: 'registerImmediately'
        }),
    ],
    providers: [NgxMaskPipe,HttpService,CustomerManageOrdersService, HelperService, ApiService , AuthGuardService,  
        CurrencyPipe,
        CustomCurrencyPipe,
        CustomTimeDurationPipe,
        // {provide: MAT_DATE_LOCALE, useValue: 'it'},
        // {provide: LOCALE_ID, useValue: 'it-IT'},
        {
            provide: LOCALE_ID,
            useValue: 'en'
        },
        {
            provide: MAT_DATE_LOCALE,
            useValue: 'en'
        },
        {provide: DateAdapter, useClass: MyDateAdapter},
        {provide: HTTP_INTERCEPTORS,useClass: TokenInterceptor, multi: true},
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] }
    ],
    exports: [
        BreadcrumbComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/');
}
